import { render } from "./ViewHouse.vue?vue&type=template&id=4f44f9c8"
import script from "./ViewHouse.vue?vue&type=script&lang=js"
export * from "./ViewHouse.vue?vue&type=script&lang=js"

import "./ViewHouse.vue?vue&type=style&index=0&id=4f44f9c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__